export default "__VITE_ASSET__VrPej_jh__"